import { Alert, Button, Col, Modal, notification, Radio, Row, Space, Typography } from 'antd'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { ModifiedModalFooter } from '../../../../elements'
import { handleBackendError } from '../../../../utils'
import { createOrderRequest } from '../../api'

const { Text } = Typography

const requiredStoreFields = [
  { key: 'address_line', label: 'Address Line' },
  { key: 'city', label: 'City' },
  { key: 'zip_code', label: 'Zip code' },
  { key: 'contact_name', label: 'Contact name' },
  { key: 'contact_phone', label: 'Contact phone' },
  { key: 'ownership_model', label: 'Ownership Model' },
]

const storeInfoFields = [
  { key: 'name', label: 'Store' },
  { key: 'country_name', label: 'Country' },
  ...requiredStoreFields,
]

const NewOrderModal = ({ hideModal, onSuccess, selectedStore }) => {
  const options = [5, 10]
  const [totesCount, setTotesCount] = useState(options[0])
  const [isLoading, setIsLoading] = useState(false)

  const missingFields = requiredStoreFields.filter(({ key }) => !selectedStore[key])
  const isStoreReady = missingFields.length === 0

  const handleSubmit = () => {
    setIsLoading(true)

    createOrderRequest({ store_id: selectedStore.id, tote_quantity: totesCount })
      .then(() => {
        notification.success({
          description: 'Admin order requested',
          title: 'Success',
        })

        onSuccess()
        hideModal()
      })
      .catch((error) => {
        notification.error({
          description: handleBackendError(error, 'Order request failed!'),
          title: 'Error',
        })
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Modal
      data-testid="newOrderModal"
      footer={[
        <ModifiedModalFooter key="padding">
          <Space>
            <Button key="back" name="cancelNewOrderModalBtnSelenium" onClick={hideModal}>
              Cancel
            </Button>
            <Button
              data-testid="submitNewOrderBtn"
              disabled={!isStoreReady}
              key="submit"
              loading={isLoading}
              name="submitNewOrderSelenium"
              onClick={handleSubmit}
              type="primary"
            >
              Request
            </Button>
          </Space>
        </ModifiedModalFooter>,
      ]}
      onCancel={hideModal}
      open
      title="New Admin Order"
    >
      <Row gutter={[16, 16]}>
        {storeInfoFields.map(({ key, label }) => (
          <Col key={key} span={12}>
            <Text type="secondary">{label}</Text>
            <div>{selectedStore[key] || '-'}</div>
          </Col>
        ))}
      </Row>

      <div style={{ marginTop: 24 }}>
        <Text type="secondary">Number of totes</Text>
        <div style={{ marginTop: 8 }}>
          <Radio.Group
            data-testid="totesCountSelect"
            onChange={(e) => setTotesCount(e.target.value)}
            options={options}
            optionType="button"
            value={totesCount}
          />
        </div>
      </div>

      {!isStoreReady && (
        <Alert
          description={`Please provide the missing details to enable tote requests: ${missingFields.map(({ label }) => label).join(', ')}`}
          showIcon
          style={{ marginTop: 24 }}
          title="Incomplete Store Profile."
          type="warning"
        />
      )}
    </Modal>
  )
}

NewOrderModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  selectedStore: PropTypes.object.isRequired,
}

export default NewOrderModal
